var map = {
	"./Travelogue_of_Changning.md": 3241,
	"./a-list-before-death.md": 9364,
	"./blogging-evolution.md": 2094,
	"./c_pointers.md": 3589,
	"./create-beautiful-restful-api.md": 5166,
	"./ddos_solution.md": 2501,
	"./intresting_jvm_crash.md": 2692,
	"./new.md": 3151,
	"./readme.md": 6547,
	"./simple_intro_of_jmm.md": 5979,
	"./talk-about-coroutines.md": 5843,
	"./talk-with-ai-completableFuture.md": 8401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4747;